/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_8_AInputs */

const en_mk_pricing_faq_8_a = /** @type {(inputs: Mk_Pricing_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`These are the prices in force now and the ones the system bills today. If they change later, existing customers are told first and the old price holds until the next billing period.`)
};

const id_mk_pricing_faq_8_a = /** @type {(inputs: Mk_Pricing_Faq_8_AInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ini harga yang berlaku sekarang dan yang ditagihkan sistem hari ini. Kalau kelak berubah, pelanggan berjalan diberi tahu lebih dulu dan harga lama tetap berlaku sampai periode tagihan berikutnya.`)
};

/**
* | output |
* | --- |
* | "These are the prices in force now and the ones the system bills today. If they change later, existing customers are told first and the old price holds until ..." |
*
* @param {Mk_Pricing_Faq_8_AInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_8_a = /** @type {((inputs?: Mk_Pricing_Faq_8_AInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_8_AInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_8_a(inputs)
	return en_mk_pricing_faq_8_a(inputs)
});